import {
  Instagram,
  Facebook,
  Youtube,
  Linkedin,
  ArrowRight,
  CreditCard,
  ShieldCheck,
  Truck,
  Leaf,
} from "lucide-react";

const Footer = () => {
  return (
    <footer className="footer">

      {/* TOP CTA */}

      <section className="footer-top">

        <div className="footer-top-content">

          <span className="footer-tag">
            JOIN THE CELIORA COMMUNITY
          </span>

          <h2>
            Begin Your
            <br />
            Glow Journey Today
          </h2>

          <p>
            Subscribe to receive skincare tips, exclusive launches,
            beauty offers and member-only rewards.
          </p>

          <div className="newsletter">

            <input
              type="email"
              placeholder="Enter your email address"
            />

            <button>

              Subscribe

              <ArrowRight size={18} />

            </button>

          </div>

        </div>

      </section>



      {/* TRUST BAR */}

      <section className="footer-trust">

        <div className="trust-card">

          <Truck />

          <div>

            <h4>Free Shipping</h4>

            <p>Orders above ₹999</p>

          </div>

        </div>


        <div className="trust-card">

          <ShieldCheck />

          <div>

            <h4>Secure Payments</h4>

            <p>100% Safe Checkout</p>

          </div>

        </div>


        <div className="trust-card">

          <Leaf />

          <div>

            <h4>Clean Beauty</h4>

            <p>Cruelty Free Formula</p>

          </div>

        </div>

      </section>



      {/* MAIN FOOTER */}

      <section className="footer-main">

        <div className="footer-bg-text">

          CELIORA

        </div>

        <div className="footer-grid">

          {/* COLUMN 1 */}

          <div>

            <h3 className="footer-logo">

              CELIORA

            </h3>

            <p className="footer-about">

              Seoul Inspired.
              <br />

              India Designed.

              <br />
              <br />

              Premium skincare crafted for
              modern lifestyles using clean
              ingredients and Korean innovation.

            </p>


            <div className="footer-social">

              <a href="#">

                <Instagram size={18} />

              </a>

              <a href="#">

                <Facebook size={18} />

              </a>

              <a href="#">

                <Youtube size={18} />

              </a>

              <a href="#">

                <Linkedin size={18} />

              </a>

            </div>

          </div>



          {/* SHOP */}

          <div>

            <h4>

              Shop

            </h4>

            <ul>

              <li><a href="#">Cleanser</a></li>

              <li><a href="#">Serum</a></li>

              <li><a href="#">Moisturizer</a></li>

              <li><a href="#">Sunscreen</a></li>

              <li><a href="#">Gift Box</a></li>

            </ul>

          </div>



          {/* SUPPORT */}

          <div>

            <h4>

              Support

            </h4>

            <ul>

              <li><a href="#">FAQ</a></li>

              <li><a href="#">Shipping</a></li>

              <li><a href="#">Returns</a></li>

              <li><a href="#">Track Order</a></li>

              <li><a href="#">Contact Us</a></li>

            </ul>

          </div>



          {/* COMPANY */}

          <div>

            <h4>

              Company

            </h4>

            <ul>

              <li><a href="#">About</a></li>

              <li><a href="#">Our Story</a></li>

              <li><a href="#">Blogs</a></li>

              <li><a href="#">Privacy Policy</a></li>

              <li><a href="#">Terms & Conditions</a></li>

            </ul>

          </div>

        </div>

      </section>



      {/* BOTTOM */}

      <section className="footer-bottom">

        <p>

          © 2026 CELIORA.
          Crafted with ❤ in India.

        </p>

        <div className="payment-icons">

          <CreditCard size={20} />

          <CreditCard size={20} />

          <CreditCard size={20} />

          <CreditCard size={20} />

        </div>

      </section>

    </footer>
  );
};

export default Footer;